import { render, staticRenderFns } from "./UnmergeDialog.vue?vue&type=template&id=5d527e7e"
import script from "./UnmergeDialog.vue?vue&type=script&lang=js"
export * from "./UnmergeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports